module.exports = __webpack_public_path__ + "img/5.97bb2a6a.jpg";